import React from 'react';
import ProductCard from './ProductCard';

export function ProductGrid(props) {
    let perRow = props.perRow ? props.perRow : 4;

    return (
        <div className={`pgrid ${getClassName(perRow)}`}>
            {props.products.map(product => {
                return <ProductCard key={product.id} product={product} perRow={perRow}/>
            })}
        </div>
    )
}

export function FauxGrid(props) {
    let items = [];

    for (let i = 0; i < props.count; i++) {
        items.push(
            <div className='product-card-item' key={i}>
                <a className='product-card'>
                    <div className="product-card__image-holder"></div>
                </a>
            </div>
        );
    }

    return (
        <div className={`pgrid ${getClassName(props.perRow)}`}>
            {items}
        </div>
    )
}

function getClassName(perRow = 4) {
    switch (perRow) {
        case 5: return 'dense-five';
        case 6: return 'dense-six';
        case 8: return 'dense-eight';
        case 4:
        default:
            return '';
    }
}
